module.exports = __webpack_public_path__ + "static/media/photo76.36d21608.jpg";